import { useCallback } from "react";
function formatNumber(localeId, num, unit) {
    // Default formatting without a unit because using the unit style with unknown units is not supported
    const numberFormat = new Intl.NumberFormat(localeId, {
        maximumFractionDigits: 17, // preserve precision, 17 is the maximum allowed
    });
    const formattedNumber = numberFormat.format(num).toString();
    // add unit manually
    return unit ? `${formattedNumber}\u00A0${unit}` : formattedNumber;
}
/**
 * @private Do not export or use in projects
 * @deprecated Only intended for use with deprecated DataTable implementation
 * @param localeId
 * @returns
 */
export function useDataTableNumberFormatter(localeId) {
    return useCallback((num, unit) => {
        return formatNumber(localeId, num, unit);
    }, [localeId]);
}
//# sourceMappingURL=useDataTableNumberFormatter.js.map